import type {ISketchObject} from '../../../../../mesh/sketch';
import {SketchRelationKind} from '../../relation-compatibility/SketchRelationKinds';
import {MultiTargetRelation} from '../MultiTargetRelation';

let count = 0;

/**
 * 判断对象是否为同心关系。
 * @param value 待判断对象。
 * @returns 是否为同心关系。
 */
export function isCircleConcentricConstraint(value: object): value is CircleConcentricConstraint {
    return Reflect.get(value, 'isCircleConcentricConstraint') === true;
}

/**
 * 圆系同心关系定义。
 *
 * 圆心等式由统一参数公式完成，本类不选择锚圆或直接平移目标。
 */
export class CircleConcentricConstraint extends MultiTargetRelation<ISketchObject> {
    /** 运行时类型标记。 */
    public readonly isCircleConcentricConstraint = true;
    /** 关系类型。 */
    public relationType = SketchRelationKind.Concentric;

    public constructor() {
        super();
        this.name = `${this.baseDisplayName}${count}`;
        count += 1;
    }

    /** 基础显示名。 */
    public get baseDisplayName(): string {
        return '同心';
    }
}
